(() => {
  const configNode=document.getElementById('EventConfig');if(!configNode)return;
  let config;try{config=JSON.parse(configNode.textContent);}catch{return;}
  const id=String(config.measurementId||'').trim();
  const validId=/^G-[A-Z0-9]{6,15}$/.test(id);
  let loaded=false;
  let privacyReady=Boolean(window.Shopify?.customerPrivacy);
  const pending=[];
  const consent=()=>{try{return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;}catch{return false;}};
  function command(){window.dataLayer=window.dataLayer||[];window.dataLayer.push(arguments);}
  const update=()=>{
    const allowed=consent();if(validId)window['ga-disable-'+id]=!allowed;
    if(!allowed||!validId||loaded)return;
    loaded=true;
    command('consent','default',{analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
    command('js',new Date());
    command('config',id,{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false});
    const script=document.createElement('script');script.async=true;script.src='https://www.googletagmanager.com/gtag/js?id='+encodeURIComponent(id);document.head.append(script);
  };
  const names=new Set(['rental_catalog_viewed','view_item','add_to_cart','remove_from_cart','view_cart','rental_dates_opened','rental_dates_selected','rental_request_started','rental_request_submitted','generate_lead']);
  window.LocasYonMetrics={track:(name,data={})=>{
    if(!names.has(name)||!validId)return false;
    if(!privacyReady){if(pending.length<20)pending.push([name,data]);return true;}
    if(!consent())return false;
    update();
    const safe={send_to:id,page_location:location.origin+location.pathname,page_referrer:''};
    for(const k of ['value','rental_days','items_count'])if(Number.isFinite(data[k])&&data[k]>=0)safe[k]=data[k];
    if(data.currency==='EUR')safe.currency='EUR';
    if(Array.isArray(data.items))safe.items=data.items.filter(p=>/^\d+$/.test(String(p.item_id))&&Number.isSafeInteger(p.quantity)&&p.quantity>0).map(p=>({item_id:String(p.item_id),quantity:p.quantity,price:Number(p.price)||0}));
    command('event',name,safe);return true;
  }};
  document.addEventListener('visitorConsentCollected',update);
  if(window.Shopify?.customerPrivacy)update();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{privacyReady=true;if(!error){update();pending.splice(0).forEach(([name,data])=>window.LocasYonMetrics.track(name,data));}else pending.length=0;});
})();
